/**
 * Archivo Js que permite definir, administrar y estandarizar los temas, colores e iconos 
 * aplicados a los componentes y vistas de la aplicacion
 */
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import es from 'vuetify/es5/locale/es';

Vue.use(Vuetify);

/**
 * Exportamos la instancia de vuetify, cuyo objecto genera variantes en los colores y temas
 */
export default new Vuetify({

  /**Objeto de definicion de tema*/
  theme: {
    options: {
      customProperties: true,
    },

    /**Definicion de colores */
    themes: {
      light: {
        primary: '#0E4174',
        secondary: '#0477BA',
        accent: '#79B2D7',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107'
      },
    },
  },

  /**Objeto definicion de lenguaje*/
  lang: {
    locales: { es },
    current: 'es',
  },

   /**Objeto definicion de la fuente de iconos*/
  icons: {
    iconfont: 'mdi',
  }
});

